module.exports = __webpack_public_path__ + "img/65700.b8bc780b.png";